import Taringa from 'src/assets/Testimonials/taringa_11zon.avif'
import Vivemas from 'src/assets/Testimonials/cityvive_11zon.avif'
import LionsClub from 'src/assets/Testimonials/ccl.avif'
import Varfaj from 'src/assets/Testimonials/varfaj_11zon.avif'
import Ingeko from 'src/assets/Testimonials/ingeko_11zon.avif'
import Servicio from 'src/assets/Testimonials/serviciodesalud_11zon.avif'
import { useTranslations } from 'src/provider/LocaleProvider'
import { Testimonial } from 'types/entities'

export function TestimonialsLabels() {
    const t = useTranslations()
    const TestimonialsContent: Testimonial[] = [
        {
            id: 1,
            title: `${t('testimonials.taringa.name')}`,
            description: `${t('testimonials.taringa.description')}`,
            image: Taringa,
        },
        {
            id: 2,
            title: `${t('testimonials.cityPrime.name')}`,
            description: `${t('testimonials.cityPrime.description')}`,
            image: Vivemas,
        },
        {
            id: 3,
            title: `${t('testimonials.varfaj.name')}`,
            description: `${t('testimonials.varfaj.description')}`,
            image: Varfaj,
        },
        {
            id: 4,
            title: `${t('testimonials.lionsClub.name')}`,
            description: `${t('testimonials.lionsClub.description')}`,
            image: LionsClub,
        },
        {
            id: 5,
            title: `${t('testimonials.specializedHealthServices.name')}`,
            description: `${t(
                'testimonials.specializedHealthServices.description'
            )}`,
            image: Servicio,
        },
        {
            id: 6,
            title: `${t('testimonials.ingeko.name')}`,
            description: `${t('testimonials.ingeko.description')}`,
            image: Ingeko,
        },
    ]
    return { TestimonialsContent }
}
